









































































































































































import Vue from 'vue'
import Site from '@/components/SeismicInsepctionForm/Site.vue'
import Geometry from '@/components/SeismicInsepctionForm/Geometry.vue'
import ValveAndLocation from '@/components/SeismicInsepctionForm/ValveAndLocation.vue'
import MethodApplicability from '@/components/SeismicInsepctionForm/MethodApplicability.vue'
import SeismicRexApplicability from '@/components/SeismicInsepctionForm/SeismicRexApplicability.vue'
import Specificities from '@/components/SeismicInsepctionForm/Specificities.vue'
import InspectionCriteria from '@/components/SeismicInsepctionForm/InspectionCriteria.vue'
import InspectionCriteria1a from '@/components/SeismicInsepctionForm/InspectionCriteria1a.vue'
import InspectionCriteria2 from '@/components/SeismicInsepctionForm/InspectionCriteria2.vue'
import InspectionCriteria3 from '@/components/SeismicInsepctionForm/InspectionCriteria3.vue'
import InspectionCriteria4 from '@/components/SeismicInsepctionForm/InspectionCriteria4.vue'
import InspectionCriteria4a from '@/components/SeismicInsepctionForm/InspectionCriteria4a.vue'
import InspectionCriteria5 from '@/components/SeismicInsepctionForm/InspectionCriteria5.vue'
import InspectionCriteria5a from '@/components/SeismicInsepctionForm/InspectionCriteria5a.vue'
import InspectionCriteria6 from '@/components/SeismicInsepctionForm/InspectionCriteria6.vue'
import SeismicCapacity from '@/components/SeismicInsepctionForm/SeismicCapacity.vue'
import Synthesis from '@/components/SeismicInsepctionForm/Synthesis.vue'
import ConclusionDeresma from '@/components/SeismicInsepctionForm/ConclusionDeresma.vue'
import SelectInspector from '@/components/TeamsManagement/SelectInspector.vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { DeresmaForm } from '@/models/SeismicForm'
import { FormsStatus } from '@/types'
import Inspector from '@/models/Inspector'

export default Vue.extend({
  components: {
    Site,
    Geometry,
    ValveAndLocation,
    Specificities,
    MethodApplicability,
    SeismicRexApplicability,
    InspectionCriteria,
    InspectionCriteria1a,
    InspectionCriteria2,
    InspectionCriteria3,
    InspectionCriteria4,
    InspectionCriteria4a,
    InspectionCriteria5,
    InspectionCriteria5a,
    InspectionCriteria6,
    SeismicCapacity,
    Synthesis,
    ConclusionDeresma,
    SelectInspector
  },
  props: {
  },
  data: () => {
    return {
      _forcedStoreRebuild: false, // If set to false anf a form is not found, will try to populate the store on "form not found"
      campaign: '',
      numeroFiche: '',
      activePage: 1,
      lastPage: 10,
      form: null as null | DeresmaForm,
      _comparisonForm: null as null | DeresmaForm, // Internally used to identify modifications in this.form
      swipeStartX: 0,
      swipeEndX: 0
    }
  },
  computed: {
    ...mapGetters(['getSeismicForm', 'getSelectedInspectors', 'getInspectors', 'getSelectedSeismicForm']),
    ...mapState(['seismicForms'])

  },
  /**
   * On form change (without leaving current route)
   * this is the way to refresh form data.
   */
  beforeRouteUpdate (to, from, next) {
    console.log('IMPOSSIBLE', (JSON.parse(JSON.stringify(this.form))))
    this.saveFormInDB()
    this.campaign = to.params.campaign
    this.numeroFiche = to.params.fiche
    this.form = this.getSeismicForm(this.campaign, this.numeroFiche)
    next()
  },
  beforeDestroy () {
    this.selectForm(null)
    this.saveFormInDB()
    window.removeEventListener('beforeunload', this.preventRefresh)
  },
  created () {
    this.campaign = this.$route.params.campaign
    this.numeroFiche = this.$route.params.fiche
    this.form = this.getSeismicForm(this.campaign, this.numeroFiche)
    // this.form = new SeismicForm((this.getSeismicForm(this.campaign, this.numeroFiche)) as Partial<SeismicForm>)
    this._comparisonForm = JSON.parse(JSON.stringify(this.form))
    this.selectForm(this.form)
    console.log('CHECK FORM INIT', this._comparisonForm)
    const selectedInspectors = this.getSelectedInspectors
    if (this.form && (!this.form.inspectors || this.form.inspectors?.length <= 0) && selectedInspectors) {
      this.form.inspectors = selectedInspectors.map((insp: Inspector) => new Inspector(insp.firstName, insp.lastName, 'not a real image'))
    }
    window.addEventListener('beforeunload', this.preventRefresh)
  },
  mounted () {
    this.lastPage = this.$el.querySelectorAll('#pages > *').length - 1

    // this.form!.numeroSchemaMecanique += ' '
    // this.saveFormInDB()
    // this.form!.numeroSchemaMecanique.trim()
    // this.saveFormInDB()
  },
  updated () {
    this._comparisonForm = JSON.parse(JSON.stringify(this.form))
    // TODO: il va peut-être falloir refaire comme dans le created
    console.log('CHECK FORM UPDATE', this._comparisonForm)
    console.log('FORM AFTER UPDATE', this.form)
    this.selectForm(this.form)
  },
  methods: {
    ...mapMutations(['SET_INDEXED_BD_REQUEST']),
    ...mapActions(['updateSeismicForm', 'selectForm']),
    changePage (ev: Event) {
      if ((ev.target as HTMLElement).tagName === 'LI') {
        this.activePage = parseInt((ev.target as HTMLElement).innerText)
      }
    },
    preventRefresh (ev: any) {
      ev.preventDefault()
      console.log('QUITTE', ev.explicitOriginalTarget.URL, ev.target.URL)
    },
    saveFormInDB: function (emittedForm?: Partial<DeresmaForm>) {
      // const form:SeismicForm = new SeismicForm((emittedForm || this.form) as Partial<SeismicForm>)

      // Add conclusions if possible
      // console.log('SAVE FORM', JSON.parse(JSON.stringify(this.form.analysis.conclusion)))
      // console.log('CHECK FORM', this.form!.calculateConclusions)
      console.log('CHECK FORM CONCLUSION', { ...this.form!.analysis.conclusion })
      console.log('CHECK FORM PREVIOUS CONCLUSION', { ...this._comparisonForm!.analysis.conclusion })
      // this.form!.calculateConclusions()

      this.form!.status = this._comparisonForm!.status === FormsStatus.todo ? FormsStatus.pending : this.form!.status

      if (
        (this.form!.analysis.conclusion.isPaidDuty !== null)) {
        this.form!.status = FormsStatus.done /* eslint-disable */
      }

      console.log('UPDATE DATE', this._comparisonForm!.status, this.form!.status)
      if ((this._comparisonForm!.status !== FormsStatus.done && this._comparisonForm!.status !== FormsStatus.other)
        && (this.form!.status === FormsStatus.done || this.form!.status === FormsStatus.other) ) {
        this.form!.updateDate = new Date()
      }

      console.log('SAVE FORM BEFORE UPDATE', JSON.parse(JSON.stringify(this.form!.analysis.conclusion)))
      this.updateSeismicForm(this.form)
      this.$forceUpdate()
    },

    selectInspector(inspector: Inspector) {
      this.form?.inspectors?.push(new Inspector(inspector.firstName, inspector.lastName, 'not a real image'))
      console.log('INSPECTORS ADD/REMOVE', JSON.parse(JSON.stringify(this.form?.inspectors)))
      this.saveFormInDB()
    },
    unselectInspector(inspector: Inspector) {
      if (this.form?.inspectors) {
        this.form.inspectors = this.form.inspectors.filter((insp) =>
          insp.firstName !== inspector.firstName || insp.lastName !== inspector.lastName
        )
        this.saveFormInDB()
        console.log('INSPECTORS ADD/REMOVE', JSON.parse(JSON.stringify(this.form.inspectors)))
      }
    },
    startDrag (event: any) { /* eslint-disable */
      event = event.changedTouches ? event.changedTouches[0] : event
      this.swipeStartX = event.clientX
    },
    endDrag (event: any) {  /* eslint-disable */
      event = event.changedTouches ? event.changedTouches[0] : event
      this.swipeEndX = event.clientX
      const diff = this.swipeEndX - this.swipeStartX
      if (diff < -150 && this.activePage < this.lastPage) {
        this.activePage++
      } else if (diff > 150 && this.activePage > 0) {
        this.activePage--
      }
    }
  }
})
